import type { ProjectDTO, ProjectLifecycle } from "@app-factory/shared";
import type { Tone } from "./primitives";

/** Popisky lifecycle stavů dle /Design (status chips). */
export const lifecycleLabel: Record<ProjectLifecycle, string> = {
  DISCOVERY: "DISCOVERY",
  ACTIVE_DEV: "ACTIVE DEV",
  LAUNCH_PREP: "LAUNCH PREP",
  LIVE: "LIVE",
  MAINTENANCE: "MAINTENANCE",
  PAUSED: "PAUSED",
  ARCHIVED: "ARCHIVED",
};

export const lifecycleTone: Record<ProjectLifecycle, Tone> = {
  DISCOVERY: "cyan",
  ACTIVE_DEV: "cyan",
  LAUNCH_PREP: "amber",
  LIVE: "red",
  MAINTENANCE: "dim",
  PAUSED: "dim",
  ARCHIVED: "dim",
};

export const kindLabel: Record<ProjectDTO["kind"], string> = {
  SAAS: "SAAS",
  CLIENT: "KLIENT",
  INTERNAL: "INTERNÍ",
  OTHER: "",
};

/**
 * Tón projektu v orbitě/seznamu — dle /Design: barva jen tam, kde hoří.
 * red = hoří (A≥90), amber = riziko (A≥80), cyan = aktivní pozornost,
 * green = zdravá maintenance, dim/off = klid.
 */
export function projectTone(p: ProjectDTO): Tone {
  if (p.lifecycle === "PAUSED" || p.lifecycle === "ARCHIVED") return "dim";
  if (p.attentionScore >= 90) return "red";
  if (p.attentionScore >= 80) return "amber";
  if (p.lifecycle === "MAINTENANCE" && (p.health ?? 0) >= 90) return "green";
  if (p.attentionScore >= 50) return "cyan";
  return "dim";
}
